const PatioVacio = [
    {
        "value": "14",
        "label": "GRUPO CIMA"
    },
    {
        "value": "13",
        "label": "Almacenajes y Maniobras Integrales del Golfo SA de CV (TIM Grupo Amigo)"
    },
    {
        "value": "12",
        "label": "TPS Terraports"
    },
    {
        "value": "11",
        "label": "TDC LOGISTICS"
    },
    {
        "value": "10",
        "label": "CICE SAN JULIÁN",
    },
    {
        "value": "9",
        "label": "ICAVE SANTA FÉ"
    },
    {
        "value": "8",
        "label": "MAEDA"
    },
    {
        "value": "7",
        "label": "CC SERVICES (CARGO AND CONTAINER SERVICES, SA DE CV"
    },
    {
        "value": "6",
        "label": "SERVICIOS Y ALMACENES DE VERACRUZ"
    },
    {
        "value": "5",
        "label": "PATIO SEABOARD"
    },
    {
        "value": "4",
        "label": "TMM LOGISTICS"
    },
    {
        "value": "3",
        "label": "CONTAINER PARK"
    },
    {
        "value": "2",
        "label": "CONTAINER CARE"
    },
    {
        "value": "1",
        "label": "ICAVE ZAL"
    },
    {
        "value": "16",
        "label": "OTROS"
    },
]

export default PatioVacio